import React from "react";
import contact from "./contact.module.css";

const Contactpaage3 = () => {
  return (
    <div className={contact.container3}>
      {/* <iframe
        src="https://maps.google.com/maps?width=600&height=400&hl=en&q=https%3A%2F%2Fwww.google.com%2Fmaps%2Fplace%2F17%25C2%25B029%2753.6%2522N%2B78%25C2%25B023%2703.4%2522E%2F%4017.49822%2C78.384279%2C17z%2Fdata%3D!3m1!4b1!4m4!3m3!8m2!3d17.49822!4d78.384279%3Fentry%3Dttu%26g_ep%3DEgoyMDI1MDYxNi4wIKXMDSoASAFQAw%253D%253D&t=&z=14&ie=UTF8&iwloc=B&output=embed"
        width="100%"
        height="450"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe> */}
      {/* <iframe
        src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3616.9158585527566!2d78.38429099999999!3d17.498265999999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTfCsDI5JzUzLjgiTiA3OMKwMjMnMDMuNSJF!5e1!3m2!1sen!2sin!4v1750496472003!5m2!1sen!2sin"
        width="100%"
        height="450"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe> */}
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d4636.272366944598!2d78.38381319318353!3d17.498836299840086!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTfCsDI5JzUzLjgiTiA3OMKwMjMnMDMuNSJF!5e0!3m2!1sen!2sin!4v1752837090263!5m2!1sen!2sin"
           width="100%"
        height="450"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
};

export default Contactpaage3;
